export default "__VITE_ASSET__D$Emj0Fa__"